module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(_vm.status === _vm.statusINTERESTED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "success",
      "text-color": "white",
      "close-icon": "mdi-check"
    }
  }, [_vm._v("Interested")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTINTERESTED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "red",
      "text-color": "white",
      "close-icon": "mdi-cancel"
    }
  }, [_vm._v("Not Interested")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINVITED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "primary",
      "text-color": "white",
      "close-icon": "mdi-account-clock"
    }
  }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED && (_vm.isAgree === null || _vm.isAgree === undefined)) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "success",
      "text-color": "white",
      "close-icon": "mdi-check"
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTACCEPTED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "red",
      "text-color": "white",
      "close-icon": "mdi-cancel"
    }
  }, [_vm._v("Not Accepted")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINQUIRY) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "info",
      "text-color": "white",
      "close-icon": "mdi-account-clock"
    }
  }, [_vm._v("Inquiry")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusELIMINATION_PENDING) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "primary",
      "text-color": "white",
      "close-icon": "mdi-account-clock"
    }
  }, [_vm._v("Not Invited")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED && _vm.isAgree === false) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "red",
      "text-color": "white",
      "close-icon": "mdi-cancel"
    }
  }, [_vm._v("Declined")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED && _vm.isAgree === true) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "success",
      "text-color": "white",
      "close-icon": "mdi-check"
    }
  }, [_vm._v("Agreed")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c04b6b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/PairingStatus.vue
// module id = 2082
// module chunks = 0